import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "jds_genderFemale",
  "use": "jds_genderFemale-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"jds_genderFemale\">\n  <path fill-rule=\"evenodd\" d=\"M7.757 4.757A6 6 0 1 1 13 14.917V17h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2v-2.084A6 6 0 0 1 7.757 4.757ZM12 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol